<!-- https://docs.google.com/presentation/d/1KmPn8M02ETfJQf1Vqgj7asd7uTOuDnkNXISaxrmoekA/edit unfinished onboarding docs -->
<!-- https://xd.adobe.com/view/c0ef1a48-887f-44ee-9131-aebb03171dd8-95bc/ unfinished onboarding ADOBE XD DESIGN -->
<!-- https://docs.google.com/presentation/d/1EV2rTg4oiYgRwFGcYJhDh8WEWSWFkNh6hlIDAn51t7A/edit#slide=id.g26f92df7adb_0_6 For Dynamic Popup -->
<!-- https://docs.google.com/presentation/d/18y2UGHM8B-KVEU54m9G7TZ8Ylzw7qoBHutk-EMJEKzk/edit#slide=id.g2a2589119e5_0_9 For Dynamic Popup / Minbolig doc -->
<template>

    <header class="app-header top-0 left-0 w-100 fixed z-50 navbar">
        <div class="flex flex-col w-100 p-0 m-0">
            <!-- <div id="reminderbarmain" class="flex justify-center items-center hidden xs-hidden sm-hidden notification-bar-danger m-0 p-0">
                <p class="m-0">Vi kunne ikke behandle din sidste betaling.</p><p @click="openpaymentreminder()" class="fw-semibold m-0 cursor-pointer"> Opdater din betaling</p>
            </div>
            <div id="payproffnotification" class="w-100 flex justify-center hidden items-center bg-yellow highlights m-0 p-0">
                <p class="m-0 p-0 pt-8 pb-8" >Verificer din <span class="fw-semibold cursor-pointer" @click="gotoPayproff()">Payproff</span></p>
            </div> -->
            <div id="mainbarmobile" class="w-100 z-10 bg-white pl-16 pr-16 justify-between items-center border-bottom hidden md-flex">

                <div class="flex-none">
                    <button class="navbar-toggler sidebar-toggler text-darkblue p-0 flex items-center bg-white" type="button" @click="sidebarToggle">
                        <svg xmlns="http://www.w3.org/2000/svg" width="28.964" height="30" viewBox="0 0 28.964 20.275">
                            <path id="menu_1_" data-name="menu (1)" d="M10.732,78.248A1.448,1.448,0,0,1,12.18,76.8H27.516a1.448,1.448,0,1,1,0,2.9H12.18A1.448,1.448,0,0,1,10.732,78.248Zm16.784,7.241H1.448a1.448,1.448,0,0,0,0,2.9H27.516a1.448,1.448,0,0,0,0-2.9Zm0,8.689H1.448a1.448,1.448,0,0,0,0,2.9H27.516a1.448,1.448,0,0,0,0-2.9Z" transform="translate(28.964 97.075) rotate(180)" fill="#002d39"/>
                        </svg>
                    </button>
                </div>

                <div class="flex justify-end items-center gap-8" style="height:55px;">

                    <div class="flex justify-center items-center" style="height: 100%;">
                        <div @click="toggleNotification" class="text-darkblue no-hover block p-0" style="height:100%;">
                            <span class="relative flex items-center pl-8 pr-8" style="height: 100%;">
                                <span v-if="alert !== 0" id="totalInbox" class='notification-badge absolute' style="right:0;top:10px;z-index:2">{{ alert > 100 ? '99+' : alert }}</span>
                                <svg xmlns="http://www.w3.org/2000/svg" id="Group_6550" data-name="Group 6550" width="23.14" height="30" viewBox="0 0 25.984 28.347">
                                    <g id="Icon_ionic-ios-notifications-outline" data-name="Icon ionic-ios-notifications-outline" transform="translate(0 0)">
                                        <path id="Path_4003" data-name="Path 4003" d="M20.7,28.336a.964.964,0,0,0-.945.759,1.865,1.865,0,0,1-.372.811,1.407,1.407,0,0,1-1.2.439,1.43,1.43,0,0,1-1.2-.439,1.865,1.865,0,0,1-.372-.811.964.964,0,0,0-.945-.759h0a.971.971,0,0,0-.945,1.184,3.326,3.326,0,0,0,3.461,2.762,3.319,3.319,0,0,0,3.461-2.762.974.974,0,0,0-.945-1.184Z" transform="translate(-5.217 -3.934)" fill="#003645"/>
                                        <path id="Path_4004" data-name="Path 4004" d="M32.433,24.69c-1.252-1.422-3.715-2.256-3.715-8.625,0-6.537-3.349-9.164-6.471-9.795-.293-.063-.5-.147-.5-.413v-.2A1.864,1.864,0,0,0,19.793,3.93h-.049a1.864,1.864,0,0,0-1.951,1.724v.2c0,.259-.211.35-.5.413-3.13.638-6.471,3.258-6.471,9.795,0,6.369-2.463,7.2-3.715,8.625-.8.918-.041,2.228,1.292,2.228H31.165A1.386,1.386,0,0,0,32.433,24.69Zm-3.17.406H10.307c-.309,0-.471-.308-.268-.511a8.443,8.443,0,0,0,1.707-2.34,13.926,13.926,0,0,0,1.162-6.179,9.609,9.609,0,0,1,1.7-6.081A5.3,5.3,0,0,1,17.753,8.05a2.981,2.981,0,0,0,1.512-.736.713.713,0,0,1,.967-.014,3.09,3.09,0,0,0,1.528.75,5.3,5.3,0,0,1,3.146,1.934,9.609,9.609,0,0,1,1.7,6.081,13.926,13.926,0,0,0,1.162,6.179,8.555,8.555,0,0,0,1.748,2.375A.287.287,0,0,1,29.263,25.1Z" transform="translate(-6.775 -3.93)" fill="#003645"/>
                                    </g>
                                </svg>
                            </span>
                        </div>
                    </div>

                    <div class="flex justify-center items-center" style="height: 100%;">
                        <a href="/messages/inbox"  class="text-darkblue no-hover block p-0" style="height:100%;">
                            <span class="relative flex items-center pl-8" style="height: 100%;">
                                <span v-if="message !== 0" id="totalInbox" class='notification-badge absolute' style="z-index:2;right:0;top:10px;">{{ message > 100 ? '99+' : message }}</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="26.68" height="17.08" viewBox="0 0 26.677 17.078">
                                    <g id="Group_8047" data-name="Group 8047" transform="translate(0 -9.001)">
                                        <g id="Group_8046" data-name="Group 8046" transform="translate(0 9.001)">
                                            <path id="Beskeder" d="M-918.916-94.932A2.033,2.033,0,0,1-921-96.909v-13.114A2.033,2.033,0,0,1-918.916-112h2.761a.508.508,0,0,1,.521.493.508.508,0,0,1-.521.493H-919l9.76,9.239a2.318,2.318,0,0,0,3.147,0l7.263-6.874h-5.754a.508.508,0,0,1-.521-.493.508.508,0,0,1,.521-.494h6.8l1.456-1.377h-15.185a.508.508,0,0,1-.521-.493.508.508,0,0,1,.521-.493h15.106a2.033,2.033,0,0,1,2.084,1.977V-96.9a2.033,2.033,0,0,1-2.084,1.977Zm-.269-1.021a1.083,1.083,0,0,0,.269.035h22.509a1.075,1.075,0,0,0,.268-.035l-7.309-6.921-1.9,1.8a3.352,3.352,0,0,1-2.31.9,3.355,3.355,0,0,1-2.311-.9l-1.9-1.8Zm16.473-7.618,7.309,6.92a.922.922,0,0,0,.036-.255v-13.117a.94.94,0,0,0-.094-.408Zm-17.241-6.452V-96.9a.913.913,0,0,0,.037.255l7.311-6.92-7.251-6.862A.931.931,0,0,0-919.953-110.023Zm13.183,2.235a.619.619,0,0,1-.619-.619.619.619,0,0,1,.619-.619h.009a.619.619,0,0,1,.619.619.619.619,0,0,1-.619.619Zm-7.02-2.97a.619.619,0,0,1-.619-.619.619.619,0,0,1,.619-.618h.007a.618.618,0,0,1,.437.18.618.618,0,0,1,.181.437.618.618,0,0,1-.181.438.617.617,0,0,1-.438.181Z" transform="translate(921 112.001)" fill="#002d39"/>
                                        </g>
                                    </g>
                                </svg>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
            <div id="mainNavbar" class="w-10 z-10 bg-white pl-24 pr-24 justify-between items-center border border-bottom flex md-hidden">
                <div class="flex-none">
                    <a href="/newsfeed" class="no-hover inline-block flex justify-start items-center">
                        <img :src="$asset('/static/svg/h.svg')" alt="" height="28" style="height: 28px!important;">
                        <span class="fs-16 ml-8 text-darkblue mb-0 fw-semibold">Håndværker.dk</span>
                    </a>
                </div>

                <div class="flex gap-24 flex-auto justify-end items-center" style="height: inherit;">
                    <div class="cursor-pointer relative">
                        <div @click="toggleNotification" class="text-easternblue no-hover block">
                            <span class="relative flex items-center">
                                <span v-if="alert !== 0" id="totalInbox" class='notification-badge absolute' style="right:-10px;top:-5px;">{{ alert }}</span>
                                <!-- <svg fill="currentColor" height="48" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M501.8 139.9H171.3c-5.6 0-10.2 4.6-10.2 10.2v19.2h-97.2c-5.6 0-10.2 4.6-10.2 10.2 0 5.6 4.6 10.2 10.2 10.2h97.2v132.5h-58.1c-5.6 0-10.2 4.6-10.2 10.2s4.6 10.2 10.2 10.2h58.1v19.2c0 5.6 4.6 10.2 10.2 10.2h330.5c5.6 0 10.2-4.6 10.2-10.2V150.1C512 144.5 507.4 139.9 501.8 139.9zM476.6 160.3l-140.1 115L197.1 160.3H476.6zM491.6 351.7h-310.1v-177.8l148.6 122.5c1.9 1.6 4.2 2.3 6.5 2.3 2.3 0 4.6-0.8 6.5-2.3L491.6 174.5V351.7z"/><path d="M119.7 244.8H10.2C4.6 244.8 0 249.3 0 255c0 5.6 4.6 10.2 10.2 10.2h109.5c5.6 0 10.2-4.6 10.2-10.2C129.9 249.3 125.3 244.8 119.7 244.8z"/><path d="M69.4 322.2h-5.5c-5.6 0-10.2 4.6-10.2 10.2 0 5.6 4.6 10.2 10.2 10.2h5.5c5.6 0 10.2-4.6 10.2-10.2C79.6 326.8 75 322.2 69.4 322.2z"/></svg> -->
                                <svg id="Group_6550" data-name="Group 6550" xmlns="http://www.w3.org/2000/svg" width="48" height="28" viewBox="0 0 33 36">
                                    <g id="Icon_ionic-ios-notifications-outline" data-name="Icon ionic-ios-notifications-outline" transform="translate(0 0)">
                                        <path id="Path_4003" data-name="Path 4003" d="M22.322,28.336a1.224,1.224,0,0,0-1.2.964,2.369,2.369,0,0,1-.473,1.03,1.787,1.787,0,0,1-1.522.558,1.816,1.816,0,0,1-1.522-.558,2.369,2.369,0,0,1-.473-1.03,1.224,1.224,0,0,0-1.2-.964h0a1.233,1.233,0,0,0-1.2,1.5,4.224,4.224,0,0,0,4.4,3.507,4.216,4.216,0,0,0,4.4-3.507,1.237,1.237,0,0,0-1.2-1.5Z" transform="translate(-2.657 2.654)" fill="#003645"/>
                                        <path id="Path_4004" data-name="Path 4004" d="M39.361,30.295c-1.59-1.806-4.718-2.865-4.718-10.953,0-8.3-4.253-11.638-8.218-12.439-.372-.08-.64-.187-.64-.525V6.119A2.368,2.368,0,0,0,23.308,3.93h-.062a2.368,2.368,0,0,0-2.478,2.189v.258c0,.329-.268.445-.64.525-3.975.81-8.218,4.137-8.218,12.439,0,8.088-3.128,9.138-4.718,10.953-1.022,1.166-.052,2.83,1.641,2.83H37.75C39.412,33.124,40.373,31.451,39.361,30.295Zm-4.026.516H11.26c-.392,0-.6-.392-.341-.65a10.723,10.723,0,0,0,2.168-2.972,17.686,17.686,0,0,0,1.476-7.848c0-3.319.723-5.917,2.158-7.723a6.728,6.728,0,0,1,4-2.456,3.786,3.786,0,0,0,1.92-.934.906.906,0,0,1,1.229-.018,3.924,3.924,0,0,0,1.941.952,6.728,6.728,0,0,1,4,2.456c1.435,1.806,2.158,4.4,2.158,7.723a17.686,17.686,0,0,0,1.476,7.848,10.865,10.865,0,0,0,2.22,3.016A.365.365,0,0,1,35.335,30.811Z" transform="translate(-6.775 -3.93)" fill="#003645"/>
                                    </g>
                                </svg>
                            </span>
                        </div>
                    </div>

                    <div class="cursor-pointer relative">
                        <a href="/messages/inbox" class="text-easternblue no-hover block">
                            <span class="relative flex items-center">
                                <span v-if="message !== 0" id="totalInbox" class='notification-badge absolute' style="right:-10px;top:-5px;">{{ message }}</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="28" viewBox="0 0 50 32">
                                    <path id="Beskeder" d="M-917.094-80A3.81,3.81,0,0,1-921-83.7v-24.6a3.81,3.81,0,0,1,3.906-3.7h5.175a.952.952,0,0,1,.977.924.952.952,0,0,1-.977.924h-5.175c-.051,0-.1,0-.151.008l18.294,17.323a4.343,4.343,0,0,0,5.9,0l13.613-12.89h-10.786a.952.952,0,0,1-.977-.924.953.953,0,0,1,.977-.926h12.738l2.729-2.583c-.049,0-.1-.008-.149-.008h-28.313a.952.952,0,0,1-.977-.924.952.952,0,0,1,.977-.924h28.313A3.81,3.81,0,0,1-871-108.3v24.6a3.81,3.81,0,0,1-3.906,3.7Zm-.5-1.913a2.031,2.031,0,0,0,.5.065h42.188a2.014,2.014,0,0,0,.5-.065l-13.7-12.976-3.567,3.377a6.283,6.283,0,0,1-4.33,1.7,6.288,6.288,0,0,1-4.332-1.7l-3.565-3.377ZM-886.722-96.2l13.7,12.974a1.72,1.72,0,0,0,.069-.477v-24.6a1.765,1.765,0,0,0-.176-.765ZM-919.048-108.3v24.6a1.736,1.736,0,0,0,.069.477l13.7-12.974-13.592-12.872A1.741,1.741,0,0,0-919.048-108.3Zm24.708,4.19a1.161,1.161,0,0,1-1.16-1.16,1.159,1.159,0,0,1,1.16-1.16h.017a1.159,1.159,0,0,1,1.16,1.16,1.161,1.161,0,0,1-1.16,1.16Zm-13.158-5.569a1.16,1.16,0,0,1-1.16-1.16A1.159,1.159,0,0,1-907.5-112h.014a1.158,1.158,0,0,1,1.159,1.158,1.158,1.158,0,0,1-1.159,1.16Z" transform="translate(921 112)" fill="#003645"/>
                                </svg>
                            </span>
                        </a>
                    </div>
                    <!--<button class="navbar-toggler sidebar-toggler pl2" type="button" @click="sidebarToggle">
                        <span class="pb1">
                            <svg viewBox="0 0 100 80" width="28" height="28">
                                <rect width="100" height="12"></rect>
                                <rect y="30" width="100" height="12"></rect>
                                <rect y="60" width="100" height="12"></rect>
                            </svg>
                        </span>
                    </button>-->
                </div>
            </div>
        </div>

    </header>
</template>
<script setup>
import { ref, computed, watch, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import axios from 'axios'

// Pinia 
import { useNotificationStore } from '@/store/notifications'
import { useMessagesStore } from '@/store/messages'
import { storeToRefs } from 'pinia'
import { captureApiException } from '@/utility/sentry'

const router = useRouter()
const route = useRoute()
const notificationStore = useNotificationStore()
const messageStore = useMessagesStore()

// State
const partnerName = ref('')
const routeName = ref('')

const message = computed(() => messageStore.unreadCount)
const alert = computed(() => notificationStore.unreadCount)

const dashdata = ref('')

// Watch        
watch(() => route.name, (newVal) => {
    if (newVal !== 'ProjectLogin') {
        routeName.value = newVal
    }
})

// Watch notification store
watch(() => notificationStore.unreadCount, (newVal) => {
    alert.value = newVal
    localStorage.setItem('alertNotifications', newVal)
})

// Lifecycle
onMounted(() => {
    // Redirect to marketplace when clicked
    if (document.querySelector('#dropMarkedsplads') !== null && typeof document.querySelector('#dropMarkedsplads') !== 'undefined') {
        setTimeout(() => {
            var maketplace = document.querySelector('#dropMarkedsplads')
            if (maketplace !== null) {
                maketplace.addEventListener('click', function () {
                    window.location.replace('/markedsplads')
                })
            }
        }, 500)
    }
    routeName.value = route.name
    
    // Set initial notification values from store
    if (notificationStore.total) {
        alert.value = notificationStore.total
    }
})

// Init (created)
partnerName.value = localStorage.getItem('name')
dashdata.value = route.query.dashdata

// Methods
function closebanner () {
    var checkpayproffbanner = document.getElementById('checkpayproffbanner')
    checkpayproffbanner.classList.add('hide')
    addorangepayproffbanner()
}

// nav methods
function sidebarToggle (e) {
    e.preventDefault()
    document.body.classList.toggle('sidebar-hidden')
    document.body.classList.toggle('sidebar-mobile-show')
}

function sidebarMinimize (e) {
    e.preventDefault()
    document.body.classList.toggle('sidebar-minimized')
    document.body.classList.toggle('sidebar-mobile-show')
}

function mobileSidebarToggle (e) {
    e.preventDefault()
    document.body.classList.toggle('sidebar-mobile-show')
}

function mailSupport () {
        router.push('/skriv-tl-support')
}

function gotoPayproff () {
    router.push('/konto-update?dashdata=' + dashdata.value)
}

function addorangepayproffbanner () {
    var payproffnotification = document.getElementById('payproffnotification')
    payproffnotification.classList.remove('hide')
}

function toggleNotification () {
    notificationStore.showSidebar = !notificationStore.showSidebar
}

async function getSupplierInfoV2 () {
    const haaid = localStorage.getItem('haaid')
    const data = {}
    try {
        const response = await axios.get(import.meta.env.VITE_BITRIXAPI + 'supplier/GetSupplierProfileByIdV2/' + haaid + '?data=company', data)
        const res = response.data.data
        const company = res['company']
        // Hide Opretilbud if no
        const bookerwizard = document.querySelector('a[href="/tilbud/jobskabelse"]')
        bookerwizard && !company['UF_CRM_COMPANY_BOOKER_WIZARD'] ? bookerwizard.classList.add('hide') : bookerwizard.classList.remove('hide')
        // Hide price calculator if no
        const priceCalc = document.querySelector('a[href="/tilbud/prisberegner"]')
        priceCalc && !company['UF_CRM_COMPANY_PRISBEREGNING'] ? priceCalc.classList.add('hide') : priceCalc.classList.remove('hide')
        // Hide fast contract if no
        const fastContract = document.querySelector('a[href="/customer-projects/fastcontract-draft"]')
        fastContract && !company['UF_CRM_COMPANY_FAST_TRACK'] ? fastContract.classList.add('hide') : fastContract.classList.remove('hide')
    } catch (error) {
        captureApiException(error, 'Header.vue', 'getSupplierInfoV2')
        console.error(error)
    }
}
</script>

<style scoped lang="scss">

header {
    #mainNavbar {
        height: 55px;
    }
}

.app-header.navbar {
    .navbar-brand {
        margin: 0 auto;

        @media (max-width: 1024px) {
            margin: 0 auto !important;
            position: relative;
            left: 0;
        }
    }
}

a:hover > span {
    color: rgba(0, 54, 69, 1);
    border: 0 !important;
}

#dropAnbefalinger::before {
    display: none !important;
}

.partnerName {
    @media (max-width: 320px) {
        position: absolute;
        right: 24px;
        top: 18px;
    }
}

#payproffnotification {
    margin-top: 50px;
    position: fixed;
    z-index: 100;
    padding-left: 10px;
    padding-right: 10px;
}

.box-bottom-shadow {
    box-shadow: 0 8px 6px -6px rgb(255, 0, 0);
}

.notification-badge {
    display: inline-block;
    padding: 2px 6px;
    border-radius: 50px;
    font-size: 12px;
    font-weight: 600;
    color: #fff;
    background-color: #dc3545;
    line-height: 1.2;
    text-align: center;
    min-width: 18px;
}

.notification-bar-danger {
    background-color: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
}

.flex-none {
    flex: none;
}

.flex-auto {
    flex: 1 1 auto;
}
</style>